import React from 'react';
import { Prospect } from '../../shared/types';
import { Button } from '../../components/ui/Button';
import { MessageSquare, PhoneCall } from 'lucide-react';

interface CTASectionProps {
  prospect: Prospect;
}

export const CTASection: React.FC<CTASectionProps> = ({ prospect }) => {
  const whatsappUrl = `https://wa.me/${prospect.whatsapp}?text=${encodeURIComponent(
    `Olá YouMachine! Quero dar o próximo passo na proposta da ${prospect.trade_name}.`
  )}`;

  return (
    <section className="py-20 relative overflow-hidden bg-white border-t border-slate-100">
      <div className="absolute inset-0 bg-gradient-to-r from-slate-50 via-white to-slate-50 opacity-50" />
      <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
        <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-6">
          Pronto para transformar a presença digital da{' '}
          <span className="text-[var(--ym-prospect-primary)]">{prospect.trade_name}?</span>
        </h2>
        <p className="text-slate-600 text-base md:text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
          Nossa equipe está pronta para iniciar o onboarding, ajustar os detalhes do seu segmento ({prospect.segment}) e colocar sua máquina de vendas no ar.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto">
            <Button variant="whatsapp" size="lg" icon={<MessageSquare className="w-5 h-5" />}>
              Aceitar Proposta no WhatsApp
            </Button>
          </a>
          <a href={`tel:${prospect.phone || prospect.whatsapp}`} className="w-full sm:w-auto">
            <Button variant="secondary" size="lg" icon={<PhoneCall className="w-5 h-5" />}>
              Solicitar Ligação
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
